import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { type VariantProps, cva } from "class-variance-authority";
import { forwardRef } from "react";

const variants = cva("rounded-full px-2 py-0.5 font-medium font-mono text-sm", {
    variants: {
        variant: {
            default: "bg-surface-secondary text-content-strong",
            success: "bg-surface-success-subtle text-content-success dark:text-content-success-subtle",
        },
        defaultVariants: {
            variant: "default",
        },
    },
});

export type CounterVariant = VariantProps<typeof variants>["variant"];

export type CounterProps = {
    counter: string;
} & VariantProps<typeof variants> &
    PropsWithClassName;

export const Counter = forwardRef<HTMLSpanElement, CounterProps>(({ counter, variant, className, ...props }, ref) => {
    return (
        <span ref={ref} className={cn(variants({ variant }), className)} {...props}>
            {counter}
        </span>
    );
});

Counter.displayName = "Counter";
